import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import Layout from "../components/layout";
import Seo from "../components/SEO";
import TechnologyPageContent from "../containers/technology-page";
import ReviewsSection from "../containers/reviews-section";
import ContactMeSection from "../containers/contact-me-section";
import { getTechnologyBySlug } from "../utils/constants/technologies";
import { breakpoints, sectionRhythm } from "../../theme";

const SectionGap = styled.div`
  height: ${sectionRhythm.gap.mobile}px;

  @media only screen and (min-width: ${breakpoints.desktop}) {
    height: ${sectionRhythm.gap.desktop}px;
  }
`;

const TechnologyTemplate = ({ pageContext }) => {
  const technology = getTechnologyBySlug(pageContext.slug);

  if (!technology) {
    return null;
  }

  return (
    <Layout>
      <Seo
        title={technology.seoTitle || technology.title}
        description={technology.seoDescription || technology.description}
      />
      <TechnologyPageContent technology={technology} />
      <ReviewsSection />
      <SectionGap aria-hidden="true" />
      <ContactMeSection />
    </Layout>
  );
};

TechnologyTemplate.propTypes = {
  pageContext: PropTypes.shape({
    slug: PropTypes.string.isRequired,
  }).isRequired,
};

export default TechnologyTemplate;
